/* eslint-disable react/jsx-props-no-spreading */
import { ICellRendererParams } from 'ag-grid-community';
import { Space } from 'antd';
import React, { useCallback } from 'react';
import { Link, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { ProjectId } from 'api/models';
import { Avatar } from 'components/atoms/avatar';
import { getProjectDetailUrl } from 'utils/urls';

const StyledLink = styled(Link)({
  color: 'initial',
  width: '100%',
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  '&:hover': {
    color: 'initial',
  },
});

const openInNewTabProps = {
  target: '_blank',
  rel: 'noopener noreferrer',
};

export const ProjectNameRenderer = ({ data, value }: ICellRendererParams) => {
  const { pathname } = useLocation();
  const markLoadTime = useCallback(
    () => performance.mark('project-plan-load-start'),
    [],
  );

  return data ? (
    <StyledLink
      to={getProjectDetailUrl(ProjectId(data.projectId))}
      onClick={markLoadTime}
      {...(pathname.includes('dashboard') ? openInNewTabProps : {})}
    >
      <Space size="small">
        <Avatar
          src={data.meta.customer.companyLogoUrl}
          name={data.meta.customer.companyName}
        />
        <div>{value}</div>
      </Space>
    </StyledLink>
  ) : null;
};
